import * as yup from 'yup';
import { ObjectSchema } from 'yup';

import emptySelectOption from '@/constants/emptySelectOption';
import { ReleaseOfInformationRecipientType } from '@/types/releaseOfInformation';

import { ROIFormValues } from './types';

export const defaultRoiFormValues: ROIFormValues = {
  roiFor: undefined,
  organization: emptySelectOption,
  person: emptySelectOption
};

const requiredOptionType = (label: string) =>
  yup.object({
    label: yup.string().default(''),
    value: yup.string().required().label(label)
  });

const nonRequiredDefaultOption = yup.object({
  label: yup.string().default(''),
  value: yup.string().default('')
});

export const roiFormSchema: ObjectSchema<ROIFormValues> = yup.object({
  roiFor: yup
    .string()
    .oneOf([
      ReleaseOfInformationRecipientType.ORGANIZATION,
      ReleaseOfInformationRecipientType.PERSON
    ])
    .label("Who's the ROI for?")
    .required(),
  organization: nonRequiredDefaultOption.when('roiFor', {
    is: ReleaseOfInformationRecipientType.ORGANIZATION,
    then: () => requiredOptionType('Organization')
  }),
  person: nonRequiredDefaultOption.when('roiFor', {
    is: ReleaseOfInformationRecipientType.PERSON,
    then: () => requiredOptionType('Person')
  })
});
